import gql from 'graphql-tag';
import { Fragments } from '../fragments';

export const updateWorkflowWithCardDefinition = gql`
  mutation UpdateWorkflowTemplateWithCardDefinitionMutation($input: UpdateWorkflowTemplate!) {
    updateWorkflowTemplate(input: $input) {
      ...WorkflowTemplateWithCardDefinition
    }
  }

  ${Fragments.workflow.WorkflowTemplateWithCardDefinition}
`;

export const updateWorkflow = gql`
  mutation UpdateWorkflowTemplateMutation($input: UpdateWorkflowTemplate!) {
    updateWorkflowTemplate(input: $input) {
      ...WorkflowTemplate
    }
  }

  ${Fragments.workflow.WorkflowTemplate}
`;

export const createWorkflow = gql`
  mutation CreateWorkflowTemplateMutation($input: CreateWorkflowTemplate!) {
    createWorkflowTemplate(input: $input) {
      ...WorkflowTemplate
    }
  }

  ${Fragments.workflow.WorkflowTemplate}
`;

export const createWorkflowApp = gql`
  mutation CreateWorkflowAppMutation($input: CreateWorkflowApp!) {
    createWorkflowApp(input: $input) {
      ...WorkflowApp
    }
  }

  ${Fragments.workflow.WorkflowApp}
`;

export const createWorkflowTemplates = gql`
  mutation CreateWorkflowTemplatesMutation($input: CreateWorkflowTemplates!) {
    createWorkflowTemplates(input: $input) {
      ...WorkflowTemplate
    }
  }

  ${Fragments.workflow.WorkflowTemplate}
`;
